import {
  AwardInputType,
  AwardType,
  AwardFormValues,
  AwardPointsOrVouchersOrNullInput,
  AwardPointsOrVouchersFormValues,
} from '@occc-app/offerHelpers/types';

import { awardInputCreator } from '../awardInputCreator';

type GetAwardInput = (values: AwardFormValues) => AwardInputType;

export const getAwardInput: GetAwardInput = ({
  awardType,
  awardPoints,
  awardVouchers,
  awardExternalPoints,
  awardExternal,
}) => {
  if (awardType === AwardType.AwardPoints && awardPoints) {
    return awardInputCreator.createAwardPoints(awardPoints.points);
  }

  if (awardType === AwardType.AwardVouchers && awardVouchers) {
    return awardInputCreator.createAwardVouchers(
      awardVouchers.voucheredOffer.id,
      awardVouchers.isEnabled ? awardVouchers.voucherExpirationDays : undefined,
    );
  }

  if (awardType === AwardType.AwardExternalPoints && awardExternalPoints) {
    return awardInputCreator.createAwardExternalPoints(awardExternalPoints.maximum);
  }

  if (awardType === AwardType.AwardExternal && awardExternal) {
    return awardInputCreator.createAwardExternal(awardExternal.provider);
  }

  if (awardType === AwardType.AwardNullable) {
    return null;
  }

  throw new Error(`${awardType} award type or its configuration is not supported or not provided`);
};

// TODO: Check if this function is still needed. Seems like getAwardInput covers all use cases.
export const getAwardPointsOrVouchersOrNullInput = ({
  awardType,
  awardPoints,
  awardVouchers,
}: AwardPointsOrVouchersFormValues): AwardPointsOrVouchersOrNullInput => {
  if (awardType === AwardType.AwardPoints && awardPoints) {
    return awardInputCreator.createAwardPoints(awardPoints.points);
  }

  if (awardType === AwardType.AwardVouchers && awardVouchers) {
    return awardInputCreator.createAwardVouchers(awardVouchers.voucheredOffer.id);
  }

  return null;
};
